
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";

const CalculeEconomia = lazy(() => import("./pages/CalculeEconomia"));
const DiagnosticoContas = lazy(() => import("./pages/DiagnosticoContas"));
const GeracaoCompartilhada = lazy(() => import("./pages/GeracaoCompartilhada"));
const GeracaoRemota = lazy(() => import("./pages/GeracaoRemota"));
const GestaoBackoffice = lazy(() => import("./pages/GestaoBackoffice"));
const GestaoFaturas = lazy(() => import("./pages/GestaoFaturas"));
const MercadoLivreBackoffice = lazy(() => import("./pages/MercadoLivreBackoffice"));
const MercadoLivreEnergia = lazy(() => import("./pages/MercadoLivreEnergia"));
const NotFound = lazy(() => import("./pages/NotFound"));
const QuemSomos = lazy(() => import("./pages/QuemSomos"));
const RessarcimentoValores = lazy(() => import("./pages/RessarcimentoValores"));
const Usinas = lazy(() => import("./pages/Usinas"));

const BeneficiosEnergiaLimpa = lazy(() => import("./pages/BeneficiosEnergiaLimpa"));
const CodigoCondutaEtica = lazy(() => import("./pages/CodigoCondutaEtica"));
const ComoFuncionaEconomia = lazy(() => import("./pages/ComoFuncionaEconomia"));
const DescompliqueContaLuz = lazy(() => import("./pages/DescompliqueContaLuz"));
const DisponibilizacaoFatura = lazy(() => import("./pages/DisponibilizacaoFatura"));
const Login = lazy(() => import("./pages/Login"));
const MercadoLivreGuia = lazy(() => import("./pages/MercadoLivreGuia"));
const ParaSuaCasa = lazy(() => import("./pages/ParaSuaCasa"));
const ParaSuaEmpresa = lazy(() => import("./pages/ParaSuaEmpresa"));
const PoliticaAnticorrupcao = lazy(() => import("./pages/PoliticaAnticorrupcao"));
const PoliticaPrivacidade = lazy(() => import("./pages/PoliticaPrivacidade"));
const QualidadeFornecimento = lazy(() => import("./pages/QualidadeFornecimento"));
const TermosUso = lazy(() => import("./pages/TermosUso"));
const TrabalheConosco = lazy(() => import("./pages/TrabalheConosco"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />

          {/* Soluções - Economizar */}

          <Route path="/solucoes/o-que-voce-precisa/quero-economizar-na-conta-de-luz/simule-sua-economia" element={<CalculeEconomia />} />
          <Route path="/solucoes/o-que-voce-precisa/quero-economizar-na-conta-de-luz/para-sua-casa" element={<ParaSuaCasa />} />
          <Route path="/solucoes/o-que-voce-precisa/quero-economizar-na-conta-de-luz/para-sua-empresa" element={<ParaSuaEmpresa />} />
          <Route path="/solucoes/pessoa-fisica" element={<CalculeEconomia />} />
          <Route path="/solucoes/pessoa-juridica" element={<Index />} />

          {/* Soluções - Geração Distribuída */}

          <Route path="/solucoes/nossos-produtos-e-servicos/geracao-distribuida/geracao-compartilhada" element={<GeracaoCompartilhada />} />
          <Route path="/solucoes/nossos-produtos-e-servicos/geracao-distribuida/geracao-remota" element={<GeracaoRemota />} />
          <Route path="/solucoes/nossos-produtos-e-servicos/geracao-distribuida/gestao-backoffice" element={<GestaoBackoffice />} />

          {/* Soluções - Mercado Livre */}

          <Route path="/solucoes/nossos-produtos-e-servicos/mercado-livre-de-energia" element={<MercadoLivreEnergia />} />
          <Route path="/solucoes/nossos-produtos-e-servicos/mercado-livre-de-energia/varejista" element={<MercadoLivreEnergia />} />
          <Route path="/solucoes/nossos-produtos-e-servicos/mercado-livre-de-energia/atacadista" element={<MercadoLivreEnergia />} />
          <Route path="/solucoes/nossos-produtos-e-servicos/mercado-livre-de-energia/gestao-backoffice" element={<MercadoLivreBackoffice />} />

          {/* Soluções - Mercado Livre */}

          <Route path="/solucoes/gestao-e-eficiencia-energetica/diagnostico-de-contas-de-energia" element={<DiagnosticoContas />} />
          <Route path="/solucoes/gestao-e-eficiencia-energetica/ressarcimento-de-valores-indevidos" element={<RessarcimentoValores />} />
          <Route path="/solucoes/gestao-e-eficiencia-energetica/gestao-completa-de-faturas" element={<GestaoFaturas />} />

          {/* Entenda sua energia */}
          
          <Route path="/entenda-sua-energia/descomplique-sua-conta-de-luz" element={<DescompliqueContaLuz />} />
          <Route path="/entenda-sua-energia/beneficios-da-energia-limpa" element={<BeneficiosEnergiaLimpa />} />
          <Route path="/entenda-sua-energia/o-mercado-livre-de-energia-guia-completo" element={<MercadoLivreGuia />} />
          <Route path="/entenda-sua-energia/como-a-thopen-gera-economia-na-conta-de-luz" element={<ComoFuncionaEconomia />} />
          {/* <Route path="/entenda-sua-energia/queda-de-energia" element={<QuedaDeEnergia />} /> */}
          <Route path="/entenda-sua-energia/qualidade-do-fornecimento" element={<QualidadeFornecimento />} />
          <Route path="/entenda-sua-energia/disponibilizacao-da-fatura" element={<DisponibilizacaoFatura />} />
          {/* <Route path="/entenda-sua-energia/queima-de-equipamento" element={<QueimaDeEquipamento />} /> */}

          {/* Quem Somos */}

          <Route path="/quem-somos" element={<QuemSomos />} />
          <Route path="/quem-somos/nossas-usinas" element={<Usinas />} />
          <Route path="/quem-somos/trabalhe-conosco" element={<TrabalheConosco />} />
          
          <Route path="/solucoes/pessoa-juridica/mercado-livre" element={<Index />} />
          <Route path="/solucoes/pessoa-juridica/gestao-otimizacao" element={<Index />} />
          <Route path="/parceiro" element={<Index />} />
          <Route path="/ri" element={<Index />} />
          <Route path="/contato" element={<Index />} />
          <Route path="/login" element={<Login />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos-uso" element={<TermosUso />} />
          <Route path="/politica-anticorrupcao" element={<PoliticaAnticorrupcao />} />
          <Route path="/codigo-conduta-etica" element={<CodigoCondutaEtica />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
